export const types = [
  { id: 1, label: "New Offer", value: "NEW_OFFER" },
  { id: 2, label: "Contract", value: "CONTRACT" },
  { id: 3, label: "Promotion", value: "PROMOTION" },
  { id: 4, label: "Transfer", value: "TRANSFER" },
  { id: 5, label: "Transfer And Promotion", value: "TRANSFER_AND_PROMOTION" },
  { id: 6, label: "Country Relocation", value: "COUNTRY_RELOCATION" },
];
